export const meta_standard = 'Meta Information Goes Here';
export const meta_404 = 'Womp womp. Looks like this link is broken.';
export const site_name = 'Paige Locke Kitchen Design';
export const site_url = 'www.paigemarielocke.com';
export const site_owner = 'Paige Marie Locke';
// export const ga_tracking_code = 'UA-120732475-1';
export const anonymousUserId = '000000000000000000000000';

export const isDevelopmentMode = document.location.hostname === 'localhost';



// WEBPACK FOOTER //
// ./src/store/constants/meta_info.js